module.exports = __webpack_public_path__ + "static/media/IconQRCode.27fd6d97.svg";